import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
var calcWidth = function calcWidth(columns) {
  return 100 / columns;
};
var getNumColumns = function getNumColumns(breakpoints, screen, defaultNumColumns) {
  if (!breakpoints) {
    return defaultNumColumns;
  }
  var attributes = breakpoints.find(function (element) {
    return element.screen === screen;
  });
  if (attributes) {
    return attributes.columns;
  }
  return defaultNumColumns;
};
var isScreenDefined = function isScreenDefined(breakpoints, screen) {
  if (!breakpoints) return false;
  var rule = breakpoints.find(function (element) {
    return element.screen === screen;
  });
  return Boolean(rule);
};
export { calcWidth, getNumColumns, isScreenDefined };